<div class="filter demographics-tab" ngModelGroup="demographicsGroup" #demographics="ngModelGroup">
  <div class="demographics-tab__race filter__column-breaker_large">
    <app-filter-item [title]="'Race'" [value]="racesValue" [clearFilter]="clearFilter('races')">
      <mat-form-field appearance="outline" class="filter__select_full">
        <mat-select multiple name="races" placeholder="Race" [(ngModel)]="demographicsGroup.races">
          <mat-option *ngFor="let item of raceOptions" [value]="item.value">
            {{item.viewValue}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </app-filter-item>
  </div>
  <div class="demographics-tab__age-group filter__column-breaker_large filter__column-breaker_medium">
    <app-filter-item [title]="'Age Group'" [value]="ageGroupValue" [clearFilter]="clearFilter('ageGroup')">
      <mat-form-field appearance="outline" class="filter__select_full">
        <mat-select name="ageGroup" placeholder="Age Group" [(ngModel)]="demographicsGroup.ageGroup">
          <mat-option *ngFor="let item of ageGroupOptions" [value]="item.value">
            {{item.viewValue}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </app-filter-item>
  </div>
  <div class="demographics-tab__gender filter__column-breaker_large">
    <app-filter-item [title]="'Gender'" [value]="genderValue" [clearFilter]="clearFilter('gender')">
      <mat-form-field appearance="outline" class="filter__select_full">
        <mat-select name="gender" placeholder="Gender" [(ngModel)]="demographicsGroup.gender">
          <mat-option *ngFor="let item of genderOptions" [value]="item.value">
            {{item.viewValue}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </app-filter-item>
  </div>
</div>
